export const AKKO_PLAN_TAGS = {
  [process.env.AKKO_PLAN_ADULT_MONTHLY || 'adult_monthly']: 'ADULT_MONTHLY',
  [process.env.AKKO_PLAN_ADULT_ANNUAL || 'adult_annual']: 'ADULT_ANNUAL',
  [process.env.AKKO_PLAN_STUDENT_MONTHLY || 'student_monthly']: 'STUDENT_MONTHLY',
  [process.env.AKKO_PLAN_STUDENT_ANNUAL || 'student_annual']: 'STUDENT_ANNUAL'
}



// WEBPACK FOOTER //
// ./src/constants/add-plan/akkoPlanTags.js